import {
  AuctionBiddingEngine,
  EAuctionBiddingEngine,
} from '@bonhams1793/bonhams-typescript'

import { cleanDoubleSlashes } from '@nx/populate-url'

import { domainBuilder } from '../domainBuilder/domainBuilder'

type BuildAuctionPathProps = {
  auctionId: string | number
  biddingEngine?: EAuctionBiddingEngine | null
  domain?: string
  slug?: string
  url?: string
}

export function buildAuctionPath({
  auctionId,
  biddingEngine,
  domain,
  slug,
  url,
}: BuildAuctionPathProps) {
  if (url) {
    if (biddingEngine === AuctionBiddingEngine.BUK) {
      return `${url}?utm_source=bonhams.com`
    }

    return url
  }

  let path = ['/auction', auctionId, slug].filter(Boolean).join('/') + '/'

  if (domain) {
    path = domainBuilder(domain, path)
  }

  return cleanDoubleSlashes(path)
}
